import { render } from "./SplashScreen.vue?vue&type=template&id=4a120aad&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=4a120aad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a120aad"

export default script